import { Link, useParams } from 'react-router-dom';
import { useConfig } from '../../config';
import { Loader } from '../Loader/Loader';
import { Tabs } from '../Tabs/Tabs';
import { TextInput } from '../../components/Form/TextInput';
import { useEffect, useState } from 'react';
import { AlphabeticListing } from '../../components/AlphabeticListing/AlphabeticListing';
import './LinkListingFilter.css';
import { useQuery } from '../../hooks/useQuery';

type UrlParams = { letter: string };

type LinkListing = {
	url: string;
	name: string;
};

type LinkListingFilter = {
	itemUrl?: string;
	isLoading?: boolean;
	links: LinkListing[];
	searchLabel: string;
	hideTabs?: boolean;
	isDense?: boolean;
	showHr?: boolean;
};

export const LinkListingFilter = ({
	links,
	isLoading,
	itemUrl,
	hideTabs,
	isDense,
	showHr,
	searchLabel,
}: LinkListingFilter): JSX.Element => {
	const { alphabet } = useConfig();
	const alphabetArr = alphabet.split('');
	const { letter = '' } = useParams<UrlParams>();
	const [searchString, setSearchString] = useState('');
	const [filteredLinks, setFilteredLinks] = useState<LinkListing[]>([]);
	const query = useQuery();

	useEffect(() => {
		setFilteredLinks([...links].filter((link) => link.name.toLowerCase().includes(searchString.toLowerCase())));
	}, [links.toString(), searchString]);

	useEffect(() => {
		setSearchString('');
	}, [letter]);

	return (
		<div className="link-listing-filter">
			{!hideTabs && (
				<Tabs>
					{alphabetArr.map((char) => (
						<li
							className={
								[letter.toLowerCase(), query.get('letter')?.toLowerCase()].includes(char.toLowerCase())
									? 'active'
									: ''
							}
							key={char}
						>
							<Link to={itemUrl ? `${itemUrl}/${char.toLowerCase()}` : `?letter=${char}`}>{char}</Link>{' '}
						</li>
					))}
					{!itemUrl && (
						<li
							className={
								[letter.toLowerCase(), query.get('letter')?.toLowerCase()].includes('other')
									? 'active'
									: ''
							}
							key={'#'}
						>
							<Link to="?letter=other">#</Link>
						</li>
					)}
				</Tabs>
			)}
			<TextInput
				className="filter-input"
				value={searchString}
				onChange={(event) => setSearchString(event.target.value)}
				placeholder={searchLabel}
			/>
			{showHr && <hr />}
			{isLoading ? <Loader /> : <AlphabeticListing isDense={isDense} removeEmpty links={filteredLinks} />}
		</div>
	);
};
